import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'zignal-landscape/lib/Checkbox';
import Field from 'zignal-landscape/lib/Field';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';

import Styles from './DashboardSettingsModal.css';

const DashboardSelectedProfiles = ({
  allProfilesSelected,
  isSubmitted,
  onChange,
  onChangeAllProfilesSelected,
  profiles,
  value
}) => {
  const selectedProfilesString = profiles.map((profile) => profile.label).join(', ');

  function handleProfilesChange(values) {
    onChange(values);
  }

  function handleIncludeAllProfilesChange() {
    onChangeAllProfilesSelected(!allProfilesSelected);
  }

  return (
    <Field>
      <Label>Included Datasets</Label>
      <div>
        <Checkbox
          id="allProfilesSelected"
          name="allProfilesSelected"
          checked={allProfilesSelected}
          onChange={handleIncludeAllProfilesChange}
        />
        <Label htmlFor="allProfilesSelected" inline>
          Include All
        </Label>
        <div className={Styles.selectProfilesWrapper}>
          {allProfilesSelected && (
            <span className={Styles.selectProfilesText}>
              {selectedProfilesString}
            </span>
          )}
          {!allProfilesSelected && (
            <Select
              blurInputOnSelect={false}
              error={isSubmitted && !value.length}
              isClearable
              isMulti
              menuPosition={'fixed'}
              menuShouldBlockScroll
              onChange={handleProfilesChange}
              options={profiles}
              value={value || []}
            />
          )}
        </div>
      </div>
    </Field>
  );
};

DashboardSelectedProfiles.propTypes = {
  allProfilesSelected: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeAllProfilesSelected: PropTypes.func,
  profiles: PropTypes.array,
  value: PropTypes.array
};

export default DashboardSelectedProfiles;
